import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { ResourceTree as LocalResourceTree } from '../../components/ResourceTree'

export const ResourceTree = connect(
  LocalResourceTree,
  mapReadPretty(LocalResourceTree, {
    onlyShowChecked: true,
    checkable: false
  })
)
